import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { LocalstorageService } from '../services/localstorage.service';
import { Router } from '@angular/router';
import { AuthDetails } from '../models/auth-details.model';
import { AuthService } from '../services/auth.service';
import { ToastrWrapperService } from '../services/toastr-wrapper.service';
import { ErrorDialogComponent } from '../dialogs/error-dialog/error-dialog.component';
import * as moment from 'moment';


@Component({
  selector: 'app-personal-info',
  templateUrl: './personal-info.component.html',
  styleUrls: ['./personal-info.component.css'],
})
export class PersonalInfoComponent implements OnInit {
  authDetails: AuthDetails;

  firstname = new UntypedFormControl('', [Validators.required]);
  lastname = new UntypedFormControl('', [Validators.required]);
  dateOfBirth = new UntypedFormControl('', [Validators.required]);
  deptnum = new UntypedFormControl('', [Validators.required]);
  leadername = new UntypedFormControl('', [Validators.required]);
  leaderemail = new UntypedFormControl('', [Validators.required, Validators.email]);
  

  constructor(private localstorageService: LocalstorageService,
    private authService: AuthService,
    private toasterWrapper: ToastrWrapperService,
    private router: Router) { }

  ngOnInit() {
    this.authDetails = this.localstorageService.getAuth();
    console.log(this.authDetails);
    if (this.authDetails != null) {
      if (this.authDetails.isAuthenticated) {
        if (this.authDetails.employeeInfo.firstName != null
          && this.authDetails.employeeInfo.lastName != null
          && this.authDetails.employeeInfo.personalEmail != null
          && this.authDetails.employeeInfo.cellPhone != null) {

          this.authDetails.personalInfo.firstName = this.authDetails.employeeInfo.firstName;
          this.authDetails.personalInfo.lastName = this.authDetails.employeeInfo.lastName;
          this.authDetails.personalInfo.personalEmail = this.authDetails.employeeInfo.personalEmail;
          this.authDetails.personalInfo.cellPhone = this.authDetails.employeeInfo.cellPhone;

          this.localstorageService.setAuth(this.authDetails);

          let redirectUrl = this.localstorageService.requestedUrl ? this.localstorageService.requestedUrl : '/';
          this.router.navigate([redirectUrl]);
        }
        else {
          this.firstname.setValue(this.authDetails.employeeInfo.firstName);
          this.lastname.setValue(this.authDetails.employeeInfo.lastName);
        }
      }
    }
  }

  getFirstNameErrorMessage() {
    return this.firstname.hasError('required') ? 'You must enter a value' : '';
  }

  getLastNameErrorMessage() {
    return this.lastname.hasError('required') ? 'You must enter a value' : '';
  }

  getDeptNumberErrorMessage() {
    return this.firstname.hasError('required') ? 'You must enter a value' : '';
  }

  getLeaderNameErrorMessage() {
    return this.firstname.hasError('required') ? 'You must enter a value' : '';
  }

  getLeaderEmailErrorMessage() {
    return this.leaderemail.hasError('required') ? 'You must enter a value' :
      this.leaderemail.hasError('email') ? 'Not a valid email' :
        '';
  }

  getDateErrorMessage(pickerInput: string): string {
    if (!pickerInput || pickerInput === '') {
      return 'Please choose a date.';
    }
  }

  isFormValid(){
    if(this.authDetails!= null && this.authDetails.isNewhire)
      return this.lastname.valid && this.firstname.valid;
    else
      return this.deptnum.valid && this.leadername.valid && this.leaderemail.valid && this.lastname.valid && this.firstname.valid;

  }

  onContinueClicked() {
    console.log("save personal info here");
    this.authDetails.personalInfo.firstName = this.firstname.value;
    this.authDetails.personalInfo.lastName = this.lastname.value;
    this.authDetails.personalInfo.deptnumber = this.deptnum.value;
    this.authDetails.personalInfo.leadername = this.leadername.value;
    this.authDetails.personalInfo.leaderemail = this.leaderemail.value;
    this.authDetails.personalInfo.personalEmail = this.authDetails.verificationData.personalEmail;
    this.authDetails.personalInfo.cellPhone = this.authDetails.verificationData.phoneNumber;
    this.authDetails.personalInfo.dateOfBirth = this.dateOfBirth.value;
    this.authDetails.personalInfo.corpId = this.authDetails.verificationData.workEmail;
    this.authDetails.personalInfo.employeeId = this.authDetails.verificationData.employeeId;

    this.savePersonalInfo();
  }

  savePersonalInfo() {
    this.authService.savePersonalInfo(this.authDetails.personalInfo).subscribe((responseData) => {
      console.log(responseData);

      this.authDetails.employeeInfo.corpId = responseData.nvCorpId;

      this.localstorageService.setAuth(this.authDetails);
      console.log(this.authDetails);

      let redirectUrl = this.localstorageService.requestedUrl ? this.localstorageService.requestedUrl : '/';
      console.log('redirectUrl', redirectUrl);
      this.router.navigate([redirectUrl]);
    },
      (error) => {
        this.handleError(error);
      }
    );
  }

  private handleError(error: any) {
    console.error(error);
    //this.isSubmitting = false;
    if (!navigator.onLine) {
      let transSaveErrorMessage = "Connection Error";
      var onlineErrorMsg = "Unable to determine a result at this time.This is usually the result of an internet connectivity issue.Would you like to submit your answers again or start the screening again?";
      //this.openErrorDialog(transSaveErrorMessage, onlineErrorMsg);
    }
    else {
      this.toasterWrapper.showError(JSON.stringify(error));
    }
  }

  //openErrorDialog(errorCode, errorMessage) {
  //  const dialogRef = this.dialog.open(ErrorDialogComponent, {
  //    width: '450px',
  //    data: { ErrorCode: errorCode, ErrorMessage: errorMessage }
  //  });

  //  dialogRef.afterClosed().subscribe(result => {
  //    console.log('The dialog was closed', result);
  //    if (result == "continue") {
  //      if (!navigator.onLine) {
  //        let transSaveErrorMessage = "Connection Error";
  //        var onlineErrorMsg = "Unable to determine a result at this time.This is usually the result of an internet connectivity issue.Would you like to submit your answers again or start the screening again?"
  //        this.openErrorDialog(transSaveErrorMessage, onlineErrorMsg);
  //      }
  //      else {
  //        this.setSelectedIndex(0);
  //      }
  //    }
  //    if (result == "submit") {
  //      if (!navigator.onLine) {
  //        let transSaveErrorMessage = "Connection Error";
  //        var onlineErrorMsg = "Unable to determine a result at this time.This is usually the result of an internet connectivity issue.Would you like to submit your answers again or start the screening again?"
  //        this.openErrorDialog(transSaveErrorMessage, onlineErrorMsg);
  //      }
  //      else {
  //        this.isLoading = true;
  //        this.submit();
  //      }
  //    }
  //  });
  //}  

  cellCarries = [{"carrierName":"Verizon"},{"carrierName":"AT&T"},{"carrierName":"Alltel"},{"carrierName":"SprintPCS"},{"carrierName":"Cingular"},{"carrierName":"Nextel"},{"carrierName":"T-Mobile"},{"carrierName":"CenturyTel"},{"carrierName":"Cricket"},{"carrierName":"US Cellular"},{"carrierName":"Boost Mobile"},{"carrierName":"Tracfone"},{"carrierName":"Puretalk USA"},{"carrierName":"ATMC"},{"carrierName":"North State Communications"},{"carrierName":"Virgin Mobile"},{"carrierName":"Net10"},{"carrierName":"Straight Talk"},{"carrierName":"USA Mobility"},{"carrierName":"Family Mobile"},{"carrierName":"Comporium Communications"},{"carrierName":"Carolina West Wireless"},{"carrierName":"AARP Consumer Cellular"},{"carrierName":"Republic Wireless"}];

}
